
export const USER_LOGINED = "USER_LOGINED";
export const EXPIRED_DATE = "EXPIRED_DATE";
export const NOTIFICATION_COUNT = "NOTIFICATION_COUNT";
export const USER_PURCHASE_STATUS = "USER_PURCHASE_STATUS" ;
export const OWNER_DATA = "OWNER_DATA" ;
export const EMPLOYEER_ID = "EMPLOYEER_ID" ;